import { createFileRoute } from "@tanstack/react-router";

import { AdminView } from "@/components/AdminView";
import { AuthGate } from "@/components/AuthGate";

export const Route = createFileRoute("/admin")({
  component: function AdminPage() {
    return (
      <AuthGate>
        <AdminView />
      </AuthGate>
    );
  },
});
